import { Container } from "../../../UI/container/Container";
import { Grid } from "@mantine/core";
import { MenuRectangle } from "../MenuRectangle";
import { appointmentHistory, calendarPhoto, medicalDoc } from "../imageLinks";
import {
  IconCalendarEvent,
  IconClipboardPlus,
  IconHistory,
} from "@tabler/icons";
import { useRouter } from "next/router";
import { useAppointmentList } from "../../../../hooks/react-query/useAppointmentList";
import { useColors } from "../../../../hooks/colors/useColors";
import { MyRoundedBadge } from "../../../UI/my-badge/MyRoundedBadge";
import { ViewHeightContainer } from "../../../UI/container/ViewHeightContainer";
import { isPhone } from "../../../../constants/env";
import { useTranslation } from "next-i18next";
import { Notifications } from "../profile/Notifications";

export function QuickLinks() {
  const router = useRouter();
  const { appointmentData } = useAppointmentList();
  const { colors } = useColors();
  const { t } = useTranslation("common");

  async function goToPage(url: string) {
    await router.push(url);
  }
  const BADGE_CLASS = isPhone
    ? "absolute top-4 right-4"
    : "absolute top-0 right-0";
  return (
    <Container noHeight>
      <ViewHeightContainer
        height="calc(100vh - 501px)"
        className="flex flex-col justify-center items-center"
      >
        <Notifications />
        <Grid>
          <Grid.Col
            className="p-8 flex justify-center relative"
            span={{ base: 12, md: 6, lg: 4 }}
          >
            <MenuRectangle
              imageSrc={calendarPhoto}
              title={t("user.manageAppsDiv")}
              onClick={() => goToPage("/user/appointments")}
              icon={<IconCalendarEvent stroke={1} size={250} color="white" />}
            />
            {appointmentData && appointmentData.length > 0 && (
              <MyRoundedBadge
                color={colors.secondaryBackground}
                size={isPhone ? 50 : 100}
                textSize={isPhone ? "25px" : "40px"}
                className={BADGE_CLASS}
                textColor={colors.secondary}
              >
                {appointmentData.length}
              </MyRoundedBadge>
            )}
          </Grid.Col>
          <Grid.Col
            className="p-8 flex justify-center"
            span={{ base: 12, md: 6, lg: 4 }}
          >
            <MenuRectangle
              imageSrc={medicalDoc}
              title={t("user.medicalDocs")}
              onClick={() => goToPage("/user/documents")}
              icon={<IconClipboardPlus stroke={1} size={250} color="white" />}
            />
          </Grid.Col>
          <Grid.Col
            className="p-8 flex justify-center"
            span={{ base: 12, md: 6, lg: 4 }}
          >
            <MenuRectangle
              imageSrc={appointmentHistory}
              title={t("user.appHistoryDiv")}
              onClick={() => goToPage("/user/appointments/history")}
              icon={<IconHistory stroke={1} size={250} color="white" />}
            />
          </Grid.Col>
        </Grid>
      </ViewHeightContainer>
    </Container>
  );
}
